import * as angular from 'angular';
import { DirectiveDefinition } from '../directiveDefinition';

interface IwtPropertyGridFieldScope extends angular.IScope {
    updateOn: any;
}

export const wtPropertyGridField: DirectiveDefinition = {
    directiveId: 'wtPropertyGridField',
    restrict: 'A',
    //replace:true,
    template: require('./propertyGridField.directive.html'),
    scope: {
        'type': '@',
        change: '&?',
        classed: '@',
        formController: '=',
        helpReference: '@',
        isDisabled: '<?',
        isOptional: '@',
        isRequired: '=?',
        label: '@',
        max: '<?',
        maxLength: '@',
        min: '<?',
        model: '=',
        modelOptions: '<?',
        pattern: '@',
        placeholder: '@',
        property: '@',
    },
    bindToController: true,
    link: (scope: IwtPropertyGridFieldScope, element, attrs) => {
        (this as any).options = {
            'updateOn': scope.updateOn
        };
    },
    controller: () => { },
    controllerAs: 'vm'
};